import Swiper from "swiper";

import {
    Navigation,
    EffectFade,
    FreeMode,
    Keyboard,
    Autoplay,
} from "swiper/modules";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/a11y";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/keyboard";

class HomeHeroCarousel {
    constructor(element) {
        // Class properties.
        this.carouselMarkUp = element;

        this.playPauseBtn = document.getElementById("mob-play-pause-btn");

        this.playIcon = document.getElementById("mob-hero-video-play-icon");
        this.pauseIcon = document.getElementById("mob-hero-video-pause-icon");

        this.createCarousel();
    }

    createCarousel() {
        this.mobHeroCarousel = new Swiper(this.carouselMarkUp, {
            modules: [Keyboard, FreeMode, Autoplay, EffectFade],
            effect: "fade",
            speed: 1000,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            containerRole: `region`,
        });

        let isPlaying = true;

        this.playPauseBtn?.addEventListener("click", (e) => {
            if (isPlaying) {
                this.mobHeroCarousel.autoplay.stop();
                this.pauseIcon.hidden = true;
                this.playIcon.hidden = false;
            } else {
                this.mobHeroCarousel.autoplay.start();
                this.pauseIcon.hidden = false;
                this.playIcon.hidden = true;
            }

            isPlaying = !isPlaying;
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const mobileHeroCarousel = document.querySelector(
        `[data-carousel="home-hero"]`,
    );

    if (mobileHeroCarousel) {
        new HomeHeroCarousel(mobileHeroCarousel);
    }
});

export default HomeHeroCarousel;
